import React from "react";
import { TS } from "~/Services/TS";
import { Language } from "~/Types/ApiModels";

export function ChooseLanguage({
    currentLanguageLookups,
    selectedLanguageCodes,
    onSelectLanguage,
}: {
    currentLanguageLookups: Language[];
    selectedLanguageCodes: string[];
    onSelectLanguage: (languageCode: string) => void;
}) {
    return (
        <div className="choose-language">
            <span className="title">{TS("Choose languages to translate")} </span>
            <ul className="language-list">
                {currentLanguageLookups.map(({ id, languageCode, description }) => (
                    <li key={id}>
                        <div className="language-list-item">
                            <div className="language-section">
                                <input
                                    type="checkbox"
                                    id={id}
                                    name={description}
                                    value={languageCode}
                                    onChange={() => onSelectLanguage(languageCode)}
                                    checked={selectedLanguageCodes.includes(languageCode)}
                                />
                                <label htmlFor={id}>{description}</label>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
